import React from 'react';
import { Popover, Tooltip } from 'antd';
import { LinkPane } from '@src/components/share/PopShare';

interface ISharingPopoverProps {
  loading: boolean;
  url: string;
  id: string;
  cid: string;
  open: boolean;
  handleOpen: (open: boolean) => void;
  children?: React.ReactNode;
}

const SharingPopover: React.FC<ISharingPopoverProps> = ({
  loading,
  url,
  id,
  cid,
  open,
  handleOpen,
  children,
}) => {
  const enhancedChild = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<any>, { loading })
    : children;

  if (loading) {
    return <Tooltip title="Loading share...">{enhancedChild}</Tooltip>;
  }

  return (
    <Popover
      content={<LinkPane url={url} id={id} customerId={cid} handleOpen={handleOpen} />}
      title="Share"
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={handleOpen}
      destroyOnHidden={true}
    >
      <Tooltip title="Share">{enhancedChild}</Tooltip>
    </Popover>
  );
};

export default SharingPopover;
